const dev = require('./index.dev');
const prod = require('./index.prod');
const staging = require('./index.staging');

const configByEnvironment = {
  development: dev,
  staging,
  production: prod
};

const config = configByEnvironment[process.env.TARGET_ENV || 'development'];

module.exports = config;
